import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import {
    ConfigurationCustomerResponse
} from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-services/configuration-local-accounting-billable-clients-customer-services.dto'
import {
    ConfigurationLocalAccountingBillableClientsModalRulesAssociation,
    ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum,
    configurationLocalAccountingBillableClientsModalRulesCentersAssociation,
    ConfigurationLocalAccountingBillableClientsModalRulesCondition,
    ConfigurationLocalAccountingBillableClientsModalRulesConditionTypeEnum,
    configurationLocalAccountingBillableClientsModalRulesInsurersAssociation,
    ConfigurationLocalAccountingBillableClientsModalRulesItem,
    configurationLocalAccountingBillableClientsModalRulesPetitionersAssociation,
    ConfigurationLocalAccountingBillableClientsModalRulesRuleItemTab,
    ConfigurationLocalAccountingBillableClientsModalRulesRuleTab,
    ConfigurationLocalAccountingBillableClientsModalRulesState,
    initialConfigurationLocalAccountingBillableClientsModalRules,
    initialConfigurationLocalAccountingBillableClientsModalRulesTab
} from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-rules/configuration-local-accounting-billable-clients-modal-rules.model'
import { CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { StrictNullable } from '@/shared/types/app.types'
import {
    configurationLocalAccountingBillableCustomerRuleSetService
} from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/automatic-customer-rule-set-services/automatic-customer-rule-set-services.service'
import {
    ConfigurationAutomaticCustomeRuleSetResponse
} from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/automatic-customer-rule-set-services/automatic-customer-rule-set-services.dto'
import { uniqueId } from 'lodash'
import { CommonCenterResponse } from '@/api/services/common/center/common-center.dto'
import { CommonInsurerResponse } from '@/api/services/common/insurer/common-insurer.dto'
import { CommonPetitionerResponse } from '@/api/services/common.dto'
import { EntityIdentifiersRequest } from '@/shared/models/http/http.model'
import ConfigurationLocalAccountingBillableClientsModalRulesVerifyRules
    from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-verify-rules/configuration-local-accounting-billable-clients-modal-rules-verify-rules.vue'
import ConfigurationLocalAccountingBillableClientsModalRulesVerifyRulesType
    from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-verify-rules/configuration-local-accounting-billable-clients-modal-rules-verify-rules'
import {
    configurationLocalAccountingBillableClientsHelpersGetCenters,
    configurationLocalAccountingBillableClientsHelpersGetInsurers,
    configurationLocalAccountingBillableClientsHelpersGetPetitioners
} from '@/modules/configurationModule/detail/local-accounting/billable/clients/shared/configuration-local-accounting-billable-clients-helpers'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationLocalAccountingBillableClientsModalRulesVerifyRules
    }
})
export default class ConfigurationLocalAccountingBillableClientsModalRules extends Vue {
    @Ref() readonly clientsModalVerifyRulesWrapper!: ConfigurationLocalAccountingBillableClientsModalRulesVerifyRulesType
    @Prop() readonly customer!: ConfigurationCustomerResponse

    @Emit()
    save(): void {}

    state: ConfigurationLocalAccountingBillableClientsModalRulesState
    constructor() {
        super()
        this.state = initialConfigurationLocalAccountingBillableClientsModalRules()
    }

    mounted(): void {
        this.state.promise = this._getAssociationsRules()
    }

    get getConditions(): ConfigurationLocalAccountingBillableClientsModalRulesCondition[] {
        return this.state.allowedConditions
    }

    get canAddAssociation(): boolean {
        const list = this.state.listRules[this.state.activeTab].list
        const foundAssociation = list.find((item: ConfigurationLocalAccountingBillableClientsModalRulesRuleItemTab) => item.type.id === this.state.allowedAssociations.selected.id)
        return !foundAssociation
    }

    get validatedModel(): boolean {
        const elementsRule = this.state.listRules[this.state.activeTab].list
        let validatedModel = elementsRule.every((item: ConfigurationLocalAccountingBillableClientsModalRulesRuleItemTab) => {
            return item.condition?.id && item.ids.length
        })
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return validatedModel && isDirty
    }

    onAddAssociation(tabIndex: number, association: ConfigurationLocalAccountingBillableClientsModalRulesAssociation): void {
        const comboLoader = this._getAllowedItems(association.id)
        this.state.listRules[tabIndex].list.push(
            {
                type: association,
                condition: null,
                ids: [],
                comboLoader
            }
        )
    }

    onRemoveAssociation(tabIndex: number, association: ConfigurationLocalAccountingBillableClientsModalRulesRuleItemTab): void {
        this.state.listRules[tabIndex].list =
            this.state.listRules[tabIndex].list.filter(item => item.type.id !== association.type.id)
    }

    async onDeleteRule(rule: ConfigurationLocalAccountingBillableClientsModalRulesRuleTab, indexTab: number): Promise<void> {
        if (rule.id) {
            const ruleToDelete: EntityIdentifiersRequest = {
                entityIdentifiers: [rule.id]
            }
            const response = await this.$_toCallSecure(configurationLocalAccountingBillableCustomerRuleSetService.delete(
                this.state.laboratoryId!,
                ruleToDelete
            ))
            if (response) {
                this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted'))
            }
        }
        const listRulesAfterDeleted = this.state.listRules.reduce((aggr, item, index) => {
            if (indexTab !== index) {
                aggr.push(item)
            }
            return aggr
        }, [] as ConfigurationLocalAccountingBillableClientsModalRulesRuleTab[])
        if (!listRulesAfterDeleted.length) {
            this.state.listRules = [initialConfigurationLocalAccountingBillableClientsModalRulesTab()]
        } else {
            this.state.listRules = listRulesAfterDeleted
        }
        this.state.activeTab = this.state.activeTab <= 0 ? 0 : this.state.activeTab - 1
    }

    addNewRule(): void {
        this.state.listRules.push(initialConfigurationLocalAccountingBillableClientsModalRulesTab())
        this.state.allowedAssociations.selected = configurationLocalAccountingBillableClientsModalRulesCentersAssociation()
        setTimeout(() => {
            this.state.activeTab = this.state.listRules.length - 1
        }, 0)
    }

    onShowClientsModalVerifyRules(): void {
        this.clientsModalVerifyRulesWrapper.show()
    }

    async onSave(rule: ConfigurationLocalAccountingBillableClientsModalRulesRuleTab): Promise<void> {
        const centers = rule.list.find((item: ConfigurationLocalAccountingBillableClientsModalRulesRuleItemTab) => item.type.id === ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum.CENTER)
        const insurers = rule.list.find((item: ConfigurationLocalAccountingBillableClientsModalRulesRuleItemTab) => item.type.id === ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum.INSURER)
        const petitioners = rule.list.find((item: ConfigurationLocalAccountingBillableClientsModalRulesRuleItemTab) => item.type.id === ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum.PETITIONER)
        const request = {
            centerRules: centers?.ids.length ? [
                {
                    centerIds: centers?.ids.map((center: ConfigurationLocalAccountingBillableClientsModalRulesItem) => center.id) as number[],
                    condition: centers?.condition?.id as string
                }
            ] : [],
            insurerRules: insurers?.ids.length ? [
                {
                    insurerIds: insurers?.ids.map((insurer: ConfigurationLocalAccountingBillableClientsModalRulesItem) => insurer.id) as number[],
                    condition: insurers?.condition?.id as string
                }
            ] : [],
            petitionerRules: petitioners?.ids.length ? [
                {
                    petitionerIds: petitioners?.ids.map((petitioner: ConfigurationLocalAccountingBillableClientsModalRulesItem) => petitioner.id) as number[],
                    condition: petitioners?.condition?.id as string
                }
            ] : []
        }
        let response
        if (rule.id) {
            const createRequest = {
                ...request,
                id: rule.id
            }
            response = await this.$_toCallSecure(configurationLocalAccountingBillableCustomerRuleSetService.patch(
                this.state.laboratoryId!,
                [createRequest]
            ))
            if (response) {
                await this._saveOk()
            }
        } else {
            const updateRequest = {
                ...request,
                customerId: this.customer?.id
            }
            response = await this.$_toCallSecure(configurationLocalAccountingBillableCustomerRuleSetService.create(
                this.state.laboratoryId!,
                updateRequest
            )) as ConfigurationAutomaticCustomeRuleSetResponse
            if (response) {
                this.state.listRules[this.state.activeTab].id = response.id
                await this._saveOk()
            }
        }
    }

    private async _saveOk(): Promise<void> {
        this.$_showToastSuccess(this.$tc('configuration.toastMessages.updated'))
        await this.$validator.reset()
        this.save()
    }

    private _getAllowedItems(association: ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum): Function {
        switch (association) {
        case ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum.CENTER:
            return configurationLocalAccountingBillableClientsHelpersGetCenters
        case ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum.INSURER:
            return configurationLocalAccountingBillableClientsHelpersGetInsurers
        case ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum.PETITIONER:
            return configurationLocalAccountingBillableClientsHelpersGetPetitioners
        }
    }

    private async _getAssociationsRules(): Promise<void> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const filterModel = {
            'customer.id': GridUtils.getNumberFilterModel('equals', this.customer.id)
        }
        const response: StrictNullable<IResponseAgGrid<ConfigurationAutomaticCustomeRuleSetResponse>> = await this.$_toCallSecure(
            configurationLocalAccountingBillableCustomerRuleSetService.paginator(filterModel, params, this.state.laboratoryId!)
        )
        if (response) {
            this.state.listRules = response.content.length ? response.content.map((item: ConfigurationAutomaticCustomeRuleSetResponse) => {
                const centerAssociation = {
                    type: configurationLocalAccountingBillableClientsModalRulesCentersAssociation(),
                    condition: {
                        id: item.centerRules[0]?.condition.code as ConfigurationLocalAccountingBillableClientsModalRulesConditionTypeEnum,
                        text: item.centerRules[0]?.condition.translatedName
                    },
                    ids: item.centerRules[0]?.centers.map((item: CommonCenterResponse) => {
                        return {
                            id: item.id,
                            text: item.name
                        }
                    }),
                    comboLoader: this._getAllowedItems(configurationLocalAccountingBillableClientsModalRulesCentersAssociation().id)
                }
                const insurerAssociation = {
                    type: configurationLocalAccountingBillableClientsModalRulesInsurersAssociation(),
                    condition: {
                        id: item.insurerRules[0]?.condition.code as ConfigurationLocalAccountingBillableClientsModalRulesConditionTypeEnum,
                        text: item.insurerRules[0]?.condition.translatedName
                    },
                    ids: item.insurerRules[0]?.insurers.map((item: CommonInsurerResponse) => {
                        return {
                            id: item.id,
                            text: item.name
                        }
                    }),
                    comboLoader: this._getAllowedItems(configurationLocalAccountingBillableClientsModalRulesInsurersAssociation().id)
                }
                const petitionerAssociation = {
                    type: configurationLocalAccountingBillableClientsModalRulesPetitionersAssociation(),
                    condition: {
                        id: item.petitionerRules[0]?.condition.code as ConfigurationLocalAccountingBillableClientsModalRulesConditionTypeEnum,
                        text: item.petitionerRules[0]?.condition.translatedName
                    },
                    ids: item.petitionerRules[0]?.petitioners.map((item: CommonPetitionerResponse) => {
                        return {
                            id: item.id,
                            text: item.fullName
                        }
                    }),
                    comboLoader: this._getAllowedItems(configurationLocalAccountingBillableClientsModalRulesPetitionersAssociation().id)
                }
                let list = []
                if (item.centerRules.length) {
                    list.push(centerAssociation)
                }
                if (item.insurerRules.length) {
                    list.push(insurerAssociation)
                }
                if (item.petitionerRules.length) {
                    list.push(petitionerAssociation)
                }
                return {
                    id: item.id,
                    itemId: uniqueId(),
                    list
                }
            }) : [initialConfigurationLocalAccountingBillableClientsModalRulesTab()]
        }
    }
}
